export default "__VITE_ASSET__CmqiDHy8__"